import { PstResultHistoryVO } from '@domain/vo/phs/pst/result/PstResultVO';
import classnames from 'classnames/bind';
import styles from './tooltip.module.scss';

const cx = classnames.bind(styles);

interface TooltipProps {
  data: PstResultHistoryVO;
  type: 'white' | 'gray';
}

export const ScoreTooltip = ({ type, data }: TooltipProps) => {
  const { score, elapsedTime, accuracyText, efficiencyText } = data;

  const getContents = () => {
    return (
      <>
        <span className={cx('text')}>점수 : {score}점</span>
        <span className={cx('text')}>소요시간 : {elapsedTime}분</span>
        <span className={cx('text')}>
          정확성 : {accuracyText} / 효율성 : {efficiencyText}
        </span>
      </>
    );
  };
  return <div className={cx('scoreTooltipArea', type)}>{getContents()}</div>;
};

interface PassedStepToolTipProps {
  data: PstResultHistoryVO;
}
export const PassedStepToolTip = ({ data }: PassedStepToolTipProps) => {
  const { passedStep } = data;

  if (passedStep === null) return null;

  return <div className={cx('passedStepToolTipArea')}>{passedStep}단계 통과</div>;
};
